import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import AuthForm from "../../Components/auth/AuthForm";
import LogoDark from "../../assets/logo.svg";
import LogoLight from "../../assets/logo-rewards-light.svg";
import styles from "../Portal/Portal.module.scss";

const LoginScreen: React.FC = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const returnTo: string | undefined = (state as any)?.from;

  return (
    <div className={styles.SignInPage}>
      <div className={styles.SignInCard}>
        <picture>
          <source srcSet={LogoLight} media="(prefers-color-scheme: dark)" />
          <img src={LogoDark} alt="Sally" className={styles.SignInLogo} />
        </picture>
        <p className={styles.SignInSubtitle}>Sign in to see your rewards</p>
        <AuthForm
          mode="signin"
          onSuccess={() => navigate(returnTo ?? "/")}
          showFooter
          below={
            <p className={styles.SignInFooterPrompt}>
              New here?{" "}
              <span
                className={styles.SignInFooterLink}
                onClick={() => navigate("/signup")}
              >
                Create an account
              </span>
            </p>
          }
        />
      </div>
    </div>
  );
};

export default LoginScreen;
